import fields from './fieldMap.json';

export default {
  fields,
};
